import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";
import { safeDomWrite, installGlobalErrorHandlers } from "@/lib/safeGuard";
import { installSyncListeners } from "@/lib/syncQueue";

installGlobalErrorHandlers();
installSyncListeners();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </ErrorBoundary>,
);

// Register service worker (PWA)
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then(() => console.log("[PWA] Service worker registered"))
      .catch((err) => console.warn("[PWA] SW registration failed", err));
  });
}

// Hide the Emergent badge (interferes with the bottom navigation on mobile).
// Wrapped in safeDomWrite so repeated calls cannot trigger infinite loops.
const hideEmergentBadge = () =>
  safeDomWrite("hide-emergent-badge", () => {
    const badge = document.getElementById("emergent-badge");
    if (badge && badge.style.display !== "none") {
      badge.style.setProperty("display", "none", "important");
    }
  });
hideEmergentBadge();
[100, 500, 1500, 3000].forEach((delay) => setTimeout(hideEmergentBadge, delay));
